import React, { useState } from "react";
import {
  AppBar,
  Box,
  IconButton,
  ListItemIcon,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import {
  AccountCircle,
  LockReset,
  Logout,
  Settings,
} from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import "./NavBar.css";
import { useUser } from "../contexts/UserProvider";
import TrailerMenu from "../Components/TrailerMenu";
import LanguageSelect from "../Components/LanguageSelect/LanguageSelect";
import { useTranslation } from "react-i18next";

export default function NavBar() {
  const [anchorElem, setAnchorElem] = useState<null | HTMLElement>(null);
  const [menu, setMenu] = useState<null | string>(null);
  const { user } = useUser();
  const { t } = useTranslation();

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    menu: string
  ) => {
    setMenu(menu);
    setAnchorElem(event.currentTarget);
  };

  const handleClose = () => {
    setMenu(null);
  };

  return (
    <AppBar position="sticky">
      <Toolbar>
        {(user?.is_admin || user?.is_operator) && (
          <React.Fragment>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              sx={{ mr: 2 }}
              onClick={(e) => {
                handleClick(e, "main");
              }}
              data-cy="nav-menu-icon"
            >
              <MenuIcon />
            </IconButton>
            {user?.is_operator && (
              <TrailerMenu
                position="left"
                id="basic-menu"
                anchorEl={anchorElem}
                open={menu === "main"}
                onClose={handleClose}
              >
                <Link to="/">
                  <MenuItem onClick={handleClose}>{t("Controls")}</MenuItem>
                </Link>
                <Link to="scenes">
                  <MenuItem onClick={handleClose}>{t("Scenes")}</MenuItem>
                </Link>
                {user?.is_admin && (
                  <Box>
                    <Link to="devices">
                      <MenuItem onClick={handleClose}>{t("Devices")}</MenuItem>
                    </Link>
                    <Link to="users">
                      <MenuItem onClick={handleClose}>{t("Users")}</MenuItem>
                    </Link>
                    <Link to="automations">
                      <MenuItem onClick={handleClose}>
                        {t("Automations")}
                      </MenuItem>
                    </Link>
                  </Box>
                )}
              </TrailerMenu>
            )}
          </React.Fragment>
        )}
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1 }}
          data-cy="nav-app-name"
        >
          Homatic
        </Typography>
        {user && (
          <Typography variant="h6" component="div" data-cy="nav-user-name">
            {user.username}
          </Typography>
        )}
        {user && (
          <React.Fragment>
            <IconButton
              size="large"
              color="inherit"
              onClick={(e) => handleClick(e, "user")}
              data-cy="nav-user-icon"
            >
              <AccountCircle />
            </IconButton>
            <TrailerMenu
              position="right"
              id="user-menu"
              anchorEl={anchorElem}
              open={menu === "user"}
              onClose={handleClose}
              data-cy="nav-user-menu"
            >
              <Link to={`profile/${user.id}`}>
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <Settings fontSize="small" />
                  </ListItemIcon>
                  {t("Profile")}
                </MenuItem>
              </Link>
              <Link to={`password/${user.id}`}>
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <LockReset fontSize="small" />
                  </ListItemIcon>
                  {t("Set Password")}
                </MenuItem>
              </Link>
              <Link
                to="/logout"
                state={{ title: "Logout", message: "Logged out successfully!" }}
              >
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  {t("Logout")}
                </MenuItem>
              </Link>
            </TrailerMenu>
          </React.Fragment>
        )}
        <LanguageSelect />
      </Toolbar>
    </AppBar>
  );
}
